<app-patient-daily-report-list
    [patientDetails]="data.patientDetails"
    [opdDetails]="data.opdDetails"
    [ipdData]="data.ipdData"
    [doctorData]="data.doctorData"
    [patientId]="data.patientId"
    [opdId]="data.opdId"
    [ipdId]="data.ipdId"
    [ipdNumber]="data.ipdNumber"
    [doctorId]="data.doctorId"
    [readOnly]="data.readOnly || false"
    [isDialog]="true"
    (reportsChanged)="onReportsChanged($event)">
</app-patient-daily-report-list>
